const config = {
  apiUrl: 'https://dev.darum.ng/',
};

export default config;
